import auditor from './auditor';
import contragent from './contragent';
import executive from './executive';
import personcontragent from './personcontragent';
import province from './province';
import inspection from './inspection';
import locality from './locality';
import district from './district';
import area from './area';
import street from './street';
import house from './house';
import user from './user';
import zvt from './zvt';
import objectexamination from './objectexamination';
import localUser from './localUser';

const catalogs = {
  auditor,
  contragent,
  executive,
  personcontragent,
  province,
  inspection,
  locality,
  district,
  area,
  street,
  house,
  user,
  objectexamination,
  zvt,
  localUser,
};

export default catalogs;
